<template>
  <div class="preloading">
    <svg-icon name="airebot"></svg-icon>
    <div class="preloading-box">
      <h1>{{ $i18.language('您好，我是TradeGPT') }}</h1>
      <span class="introduce" v-if="['TR'].includes($util.judgeOrigin())">{{ $i18.language('作为特易资讯的外贸大数据人工智能助理，可以帮助您查数据、做分析，让外贸数字化营销获客更简单。(TRU)') }}</span>
      <span class="introduce" v-else>{{ $i18.language('作为特易资讯的外贸大数据人工智能助理，可以帮助您查数据、做分析，让外贸数字化营销获客更简单。') }}</span>
      <span class="introduce">{{ $i18.language('你可以试着问我：') }}</span>
      <div class="pre-question">
        <div class="question-item" v-for="(item, index) in formatPictureList" :key="index" @click="askPreQusetion(item)">
          <el-image fit="contain" :src="isRight==1?item.url_small:item.url_big">
            <div slot="placeholder" class="image-slot">
              <div :class="'loading_'+isRight"></div>
            </div>
          </el-image>
          <div class="info">
            <span class="title">{{ item.title }}</span>
            <span v-if="item.desc" class="desc" v-html="item.desc"></span>
            <el-skeleton v-else class="desc" :rows="1" animated>
              <template slot="template">
                <el-skeleton-item variant="p" :style="`width: ${Math.floor(Math.random() * 55 + 45)}%`" />
              </template>
            </el-skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isRight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pictureslist: [
        {
          url_big: require(`@/assets/AIGPT/check_purchase.png`),
          url_small: require(`@/assets/AIGPT/check_purchase_right.png`),
          title: this.$i18.language('查采购/供应商'),
          value: 1,
          desc: '',
        }, {
          url_big: require(`@/assets/AIGPT/check_supplier.png`),
          url_small: require(`@/assets/AIGPT/check_supplier_right.png`),
          title: this.$i18.language('查联系人'),
          value: 5,
          desc: '',
        }, {
          url_big: require(`@/assets/AIGPT/check_trade_data.png`),
          url_small: require(`@/assets/AIGPT/check_trade_data_right.png`),
          title: this.$i18.language('查交易情报'),
          value: 2,
          desc: '',
        }, {
          url_big: require(`@/assets/AIGPT/check_statistic.png`),
          url_small: require(`@/assets/AIGPT/check_statistic_right.png`),
          title: this.$i18.language('查统计数据'),
          value: 3,
          desc: '',
        }, {
          url_big: require(`@/assets/AIGPT/read_MS_Report.png`),
          url_small: require(`@/assets/AIGPT/read_MS_Report_right.png`),
          title: this.$i18.language('解读市场研究报告'),
          value: 4,
          desc: '',
        }, {
          url_big: require(`@/assets/AIGPT/write_email.png`),
          url_small: require(`@/assets/AIGPT/write_email_right.png`),
          title: this.$i18.language('撰写商务邮件'),
          value: '',
          desc: '',
        }
      ],
      randomObj: {
        countryName: '',
        mainSelProduct: '',
        purchaseCompanyName: '',
        supplierCompanyName: '',
      },
    };
  },
  computed: {
    formatPictureList() {
      let gt6_user_info = localStorage.getItem("gt6_user_info") ? JSON.parse(localStorage.getItem("gt6_user_info")) : ""
      let notShow = ["白银C版", "白银G版", "黄金C版", "黄金G版"]
      return notShow.includes(gt6_user_info.permission) || ["TR"].includes(this.$util.judgeOrigin()) ? this.pictureslist.filter(e=>e.value!=3) : this.pictureslist
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.$api.dashboard.getUserInfo().then(async (res) => {
        if (res.code == 200) {
          await this.randomRes(res)
        } else {
          this.randomALL()
        }
      }).catch(err=>this.randomALL())
    },
    async randomRes(res) {
      let newMainSelProduct = res.data.gt6_products_interested
      if(newMainSelProduct && newMainSelProduct.length) {
        newMainSelProduct = newMainSelProduct.filter(e=>e.value).map(e=>e.value)
      }
      let mainSelProduct = this.getRandomItem(newMainSelProduct) || "led"
      // 将 interestedCountryIds 和 interestedCountryNames 添加到 res.data 对象中
      res.data.interestedCountryIds = [];
      res.data.interestedCountryNames = [];
      // gt6_interested_countrys 数组并填充 interestedCountryIds 和 interestedCountryNames
      if (res.data && Array.isArray(res.data.gt6_interested_countrys)) {
        res.data.gt6_interested_countrys.forEach((item) => {
          res.data.interestedCountryIds.push(item.countryId);
          res.data.interestedCountryNames.push(item.countryName);
        });
      }
      const isUseInitCountry = res.data.interestedCountryIds[0] != 0 && res.data.interestedCountryIds.length > 0
      let resInterestedCountry = await this.countryPermissions(isUseInitCountry, res.data)
      this.$api.trade.getTranslateBath({keywords: [mainSelProduct]}).then(async (trans) => {
        if (trans.code == 200 && trans.data !== "ERROR") {
          let productDescriptions = trans.data.map(e => {
            return {type: 'or', trans: [...e.data], value: mainSelProduct}
          })
          const params = {
            type: 1,
            pageIndex: 1,
            pageSize: 10,
            tradeCount: -1, // 以上均为默认参数
            tradeDate: 2, // 查近两年有交易数据的企业
            excludeBuyerEmpty: true,
            excludeSupplierEmpty: true,
            excludeBankBuyer: true,
            excludeBankSupplier: true,
            excludeLogisticsBuyer: true,
            excludeLogisticsSupplier: true,
            productDescriptions,
            countryIds: resInterestedCountry.countryIds,
          }
          const params2 = {...params, type: 2}
          // 查采购商
          const { data: { result: purchaseList } } = await this.$api.company.searchCompany(params)
          // 查供应商
          const { data: { result: supplierList } } = await this.$api.company.searchCompany(params2)

          const { data: reportType } = await this.$api.ai.getReportType()
          
          this.randomObj = {
            mainSelProduct,
            countryName: resInterestedCountry.countryName,
            reportIndustryName: this.getRandomItem(reportType.report_type),
            reportCountryName: this.getRandomItem(reportType.report_country),
            purchaseCompanyName: purchaseList.length > 0 ? this.getRandomItem(purchaseList).companyName : "APPLE INC.",
            supplierCompanyName: supplierList.length > 0 ? this.getRandomItem(supplierList).companyName : "APPLE INC.",
          }
          // console.log(supplierList);
          // console.log(this.randomObj);
          
          this.pictureslist = this.pictureslist.map((el, index) => {
            return {
              ...el,
              desc: this.getRandomItem(this.initQuestArr()[index])
            }
          })
        } else {
          this.randomALL(mainSelProduct, resInterestedCountry.countryName)
        }
      })
    },
    countryPermissions(isUseInitCountry, resdata) {
      return new Promise((resolve, reject) => {
        let resInterestedCountry
        // 如果至少有一个感兴趣的国家，否则就使用默认值
        if (isUseInitCountry) {
          let index = this.getRandomIndex(resdata.interestedCountryIds)
          resInterestedCountry = {
            countryIds: resdata.interestedCountryIds[index],
            countryName: resdata.interestedCountryNames[index],
          }
          resolve(resInterestedCountry)
        } else {
          this.$api.home.getHomeData().then(countryRes => {
            // 剔除无权限的国家，然后取每个洲的前两个国家，再进行数组扁平化处理
            let filteredArray = countryRes.data.country.map(item => ({
              ...item,
              children: item.children.filter(child => child.isOpen).slice(0, 2)
            })).map(item => item.children).flat();

            let item = this.getRandomItem(filteredArray)
            resInterestedCountry = {
              countryIds: item.id,
              countryName: item.name,
            }
            resolve(resInterestedCountry)
          })
        }
      })
    },
    randomALL(mainSelProduct, countryName) {
      // 默认值:美国 or 印度
      let initCountry = [
        {
          name: this.$i18.language("美国"),
          id: 214,
        },{
          name: this.$i18.language("印度"),
          id: 94
        }
      ]
      this.randomObj = {
        mainSelProduct: mainSelProduct || "led",
        countryName: countryName || this.getRandomItem(initCountry).name,
        purchaseCompanyName: "APPLE INC.",
        supplierCompanyName: "APPLE INC."
      }
      this.pictureslist = this.pictureslist.map((el, index) => {
        return {
          ...el,
          desc: this.getRandomItem(this.initQuestArr()[index])
        }
      })
    },
    initQuestArr() {
      let {countryName, mainSelProduct, purchaseCompanyName, supplierCompanyName, reportIndustryName, reportCountryName} = this.randomObj
      // let date = this.getRandomItem(['最近三个月', '最近六个月', '最近一年'])
      let year = this.getRandomItem([new Date().getFullYear(), new Date().getFullYear() - 1])
      let language = this.getRandomItem(
        [
          this.$i18.language("英语"),
          this.$i18.language("西班牙语"),
          this.$i18.language("法语"),
          this.$i18.language("德语"),
          this.$i18.language("日语"),
          this.$i18.language("韩语"),
          this.$i18.language("意大利语"),
          this.$i18.language("葡萄牙语"),
        ]
      )
      let attitude = this.getRandomItem(
        [
          // this.$i18.language("有说服力"),
          this.$i18.language("尊敬"),
          this.$i18.language("礼貌"),
          // this.$i18.language("自信"),
          this.$i18.language("正式商务"),
        ]
      )
      let arr = [
        [
          this.$i18.language(`帮我查一下供应商{supplierCompanyName}有哪些采购商？`),
          this.$i18.language(`请问{countryName}市场上{mainSelProduct}产品的采购商有哪些？`),
          this.$i18.language(`在{countryName}排名前十的{mainSelProduct}商品采购商有哪些？`),
          this.$i18.language(`{year}年采购{mainSelProduct}商品的{countryName}采购商有哪些？`),
          this.$i18.language(`{year}年{countryName}市场上采购{mainSelProduct}产品的采购商有哪些？`),
          this.$i18.language(`{countryName}市场上{mainSelProduct}产品排名前十的供应商有哪些？`),
          this.$i18.language(`帮我查一下{purchaseCompanyName}这家公司有哪些中国供应商？`),
          this.$i18.language(`{year}年提供{mainSelProduct}产品的{countryName}供应商有哪些？`),
          this.$i18.language(`帮我查一下采购商{purchaseCompanyName}有哪些供应商？`),
        ],
        [
          this.$i18.language(`请帮我查找一下{supplierCompanyName}这家公司的联系方式？`),
          this.$i18.language(`{purchaseCompanyName}公司网址以及联系方式是？`),
          this.$i18.language(`{countryName}市场上的{mainSelProduct}采购商以及联系方式？`),
        ],
        [
          this.$i18.language(`{purchaseCompanyName}主要采购了哪些商品？`),
          this.$i18.language(`{purchaseCompanyName}这家采购商最近一年有没有过交易记录？`),
          this.$i18.language(`{purchaseCompanyName}主要采购了什么商品？`),
          this.$i18.language(`{purchaseCompanyName}主要从哪些国家采购？`)
        ],
        [
          this.$i18.language(`{mainSelProduct}商品到哪些国家找买家？`),
          this.$i18.language(`中国出口的{mainSelProduct}商品主要进口到了哪些国家？`),
          this.$i18.language(`哪些国家从中国进口{mainSelProduct}商品？`),
        ],
        [
          this.$i18.language(`{reportIndustryName}行业的市场状况？`),
          this.$i18.language(`{reportIndustryName}行业有哪些头部公司？`),
          this.$i18.language(`{reportIndustryName}行业的市场容量情况？`),
          this.$i18.language(`{reportCountryName}的经济情况？`),
          this.$i18.language(`{reportCountryName}的贸易情况？`),
        ],
        [
          this.$i18.language(`请帮我撰写{mainSelProduct}商品的{language}开发信，描述一下我们公司的发展历史`),
          this.$i18.language(`请帮我撰写{mainSelProduct}商品的{language}开发信，描述一下我们{mainSelProduct}产品的质量优异`),
          this.$i18.language(`请帮我撰写{mainSelProduct}商品的{language}开发信，描述一下我们公司售后服务完善`),
          this.$i18.language(`请帮我撰写{mainSelProduct}商品的{language}开发信，语气{attitude}一些`),
          this.$i18.language(`请帮我撰写一个催款邮件，让客户收到货物之后尽快付款，语气{attitude}一些`),
          this.$i18.language(`请帮我撰写一个邮件，询问客户为什么不回复我的报价，语气{attitude}一些`),
          this.$i18.language(`请帮我撰写一个春节假期通知，语气{attitude}一些`),
        ],
      ]
      // 遍历二维数组
      for (let i = 0; i < arr.length; i++) {
        // 遍历内部数组
        for (let j = 0; j < arr[i].length; j++) {
          arr[i][j] = arr[i][j].replace(/\{countryName\}/g, countryName);
          arr[i][j] = arr[i][j].replace(/\{mainSelProduct\}/g, mainSelProduct);
          arr[i][j] = arr[i][j].replace(/\{purchaseCompanyName\}/g, purchaseCompanyName);
          arr[i][j] = arr[i][j].replace(/\{supplierCompanyName\}/g, supplierCompanyName);
          arr[i][j] = arr[i][j].replace(/\{year\}/g, year);
          arr[i][j] = arr[i][j].replace(/\{reportCountryName\}/g, reportCountryName || '');
          arr[i][j] = arr[i][j].replace(/\{reportIndustryName\}/g, reportIndustryName || '');
          arr[i][j] = arr[i][j].replace(/\{language\}/g, language);
          arr[i][j] = arr[i][j].replace(/\{attitude\}/g, attitude);
        }
      }

      return arr
    },
    getRandomItem(arr) {
      return arr[Math.floor(Math.random() * arr.length)]
    },
    getRandomIndex(arr) {
      return Math.floor(Math.random() * arr.length)
    },
    askPreQusetion(item){
      // 提问的内容
      this.$parent.qusetiontextarea = item.desc
      // 提问题的类型的htmlText展示
      this.$parent.changeQuestionType(item, true)
      this.$nextTick(()=>{
        this.$parent.$refs.inputRef.focus()
      })
    },
  },
};
</script>

<style scoped lang="scss">
.preloading {
  display: flex;
  align-items: flex-start;
  margin: 24px 0 0 0; 
  padding: 0 35px 20px 35px;
  height: 450px;
  background-color: $--color-white;
  border-radius: 15px;
  overflow-y: auto;
  width: 810px;
  position: relative;
  svg {
    font-size: 26px;
    position: absolute;
    left: 0;
  }
  .preloading-box {
    // flex: 1;
    width: 772px;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 16px;
    background-color: #EFF1F2;
    border-radius: 15px;
    // &:before{
    //   width: 0px;
    //   height: 0px;
    //   content: "";
    //   border-top: 10px solid transparent;
    //   border-bottom: 10px solid transparent;
    //   border-right: 10px solid $--background-color-base;
    //   position: absolute;
    //   top: 10px;
    //   left: -10px;
    // }
    h1 {
      font-size: 24px;
      color: $--color-title;
      padding-bottom: 10px;
    }
    .introduce {
      color: $--color-desc;
      line-height: 1.5;
    }
    .pre-question {
      display: flex;
      flex-wrap: wrap;
      .question-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        flex:0 0 50%;
        .el-image {
          padding: 5px 0;
          .loading_1 {
            width: 186px;
            border-radius: 10px;
            height: 95px;
            background: #ffffff;
          }
          .loading_0 {
            width: 376px;
            border-radius: 10px;
            height: 84px;
            background: #ffffff;
          }
        }
        .info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 16px;
          height: 100%;
          .title {
            font-size: 16px;
            color: $--color-title;
            padding-bottom: 7px;
          }
          .desc {
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            width: 350px;
            // font-size: $--font-size-small;
            color: $--color-desc;
            word-wrap: break-word;
            line-height: 16px;
            /deep/ strong {
              font-weight: 900;
              font-size: 16px;
              color: $--color-title;
            }
          }
        }
      }
      .question-item:nth-of-type(odd) {
        .el-image {
          padding-right: 10px;
        }
      }
    }
  }
}

</style>
